var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fileupload"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":12}},[_c('el-card',{staticClass:"box-card",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"el-icon-folder-checked"}),_vm._v(" "),_c('span',[_vm._v("作品相关文件")])]),_vm._v(" "),_vm._l((_vm.completeArray),function(item,index){return _c('div',{key:index,staticClass:"text item"},[_c('div',[_c('el-row',[_c('el-col',{attrs:{"span":8}},[(_vm.attrs[0].indexOf(item.type) != -1)?_c('img',{staticStyle:{"width":"100px","height":"50px"},attrs:{"src":item.path}}):_vm._e(),_vm._v(" "),(
                    _vm.attrs[2].indexOf(
                      item.fileName.substring(
                        item.fileName.lastIndexOf('.'),
                        item.fileName.length
                      )
                    ) != -1
                  )?_c('i',{staticClass:"el-icon-document",staticStyle:{"font-size":"50px"}}):_vm._e()]),_vm._v(" "),(
                  _vm.attrs[2].indexOf(
                    item.fileName.substring(
                      item.fileName.lastIndexOf('.'),
                      item.fileName.length
                    )
                  ) != -1
                )?_c('el-col',{attrs:{"span":12}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":item.fileName,"placement":"top-start"}},[_c('span',[_vm._v(_vm._s(item.fileName))])])],1):_vm._e(),_vm._v(" "),(
                  _vm.attrs[0].indexOf(
                    item.fileName.substring(
                      item.fileName.lastIndexOf('.'),
                      item.fileName.length
                    )
                  ) != -1
                )?_c('el-col',{attrs:{"span":12}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":item.fileName,"placement":"top-start"}},[_c('span',[_vm._v(_vm._s(item.fileName))])])],1):_vm._e(),_vm._v(" "),(
                  _vm.attrs[1].indexOf(
                    item.fileName.substring(
                      item.fileName.lastIndexOf('.'),
                      item.fileName.length
                    )
                  ) != -1
                )?_c('el-col',{attrs:{"span":12}},[_c('span',[_vm._v(_vm._s(item.fileName))]),_vm._v(" "),_c('video-player',{ref:"videoPlayer",refInFor:true,staticClass:"video-player vjs-custom-skin",attrs:{"playsinline":true,"options":{
                    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: false, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [
                      {
                        type:
                          'video/mp4' ||
                          'video/x-flv' ||
                          'video/webm' ||
                          'video/ogg',
                        src: item.path, //url地址
                        // src: "" //url地址
                      } ],
                    poster: '', //你的封面地址
                    // width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                      timeDivider: true,
                      durationDisplay: true,
                      remainingTimeDisplay: false,
                      fullscreenToggle: true, //全屏按钮
                    },
                  }}})],1):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[(
                    _vm.attrs[1].indexOf(
                      item.fileName.substring(
                        item.fileName.lastIndexOf('.'),
                        item.fileName.length
                      )
                    ) == -1
                  )?_c('i',{staticClass:"el-icon-download",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.download(item.path)}}}):_vm._e()])],1)],1)])})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58b5872e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fileComponentList.vue
// module id = null
// module chunks = 